module.exports = __webpack_public_path__ + "img/logo_detik.c8600b67.png";